import { useEffect, useRef, useState } from 'react';
import { usePersistentCallback } from '../hooks';
export const useAudioPlayer = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);
    const play = usePersistentCallback((audioUrl) => {
        return new Promise((resolve) => {
            if (audioRef.current) {
                audioRef.current.pause();
                URL.revokeObjectURL(audioRef.current.src);
            }
            audioRef.current = new Audio(audioUrl);
            const handleEnded = () => {
                var _a;
                setIsPlaying(false);
                (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('ended', handleEnded);
                resolve();
            };
            audioRef.current.addEventListener('ended', handleEnded);
            audioRef.current.play().then(() => {
                setIsPlaying(true);
            });
        });
    });
    const pause = usePersistentCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        }
    });
    const stop = usePersistentCallback(() => {
        destroy();
        setIsPlaying(false);
    });
    const destroy = usePersistentCallback(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            URL.revokeObjectURL(audioRef.current.src);
            audioRef.current = null;
        }
    });
    useEffect(() => destroy, [destroy]);
    return { play, stop, isPlaying, pause };
};
